import * as types from './ActiveFiltersActionTypes.js';

const initialState = {
    graphOverviewFilters: [],
    projectOverviewFilters: [],
};

export default function ActiveFilters(state = initialState, action) {
    switch (action.type) {
        case types.SET_GRAPHOVERVIEWFILTERS:
            if (action.payload !== state.graphOverviewFilters) {
                return Object.assign({}, state, { graphOverviewFilters: action.payload });
            }
            return state;
        case types.SET_PROJECTOVERVIEWFILTERS:
            if (action.payload !== state.projectOverviewFilters) {
                return Object.assign({}, state, { projectOverviewFilters: action.payload });
            }
            return state;
        case types.RESET_ACTIVEFILTERS:
            return { ...initialState };

        default: {
            return state;
        }
    }
}